import { useQuery } from '@tanstack/react-query'
import type { ReadSideRepository } from './read-side-status'

// Read status moves at the pace of sync work, not seconds. Every open Overview,
// Patients and Settings page polls it, and each answer costs about 20 database
// reads (2026-10-21), so a syncing clinic is re-read each minute and a READY one
// every five minutes.
export const READ_SIDE_SYNCING_REFRESH_MS = 60_000
export const READ_SIDE_READY_REFRESH_MS = 5 * 60_000

export function useReadSideStatus(
  repository: ReadSideRepository | undefined,
  tenantId: string
) {
  return useQuery({
    queryKey: ['read-side', tenantId],
    queryFn: () => repository!.getStatus(tenantId),
    enabled: !!repository && !!tenantId,
    staleTime: READ_SIDE_SYNCING_REFRESH_MS,
    refetchInterval: (query) =>
      query.state.data?.state === 'READY'
        ? READ_SIDE_READY_REFRESH_MS
        : READ_SIDE_SYNCING_REFRESH_MS,
    retry: 1,
  })
}
